var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1176.255,
    height: 287.613,
    viewBox: "0 0 1176.255 287.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Itaberai",
    transform: "translate(4165 -1152.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M238.958,322.344H48.665A48.685,48.685,0,0,1,0,273.689V83.386A48.671,48.671,0,0,1,48.665,34.731H238.958a48.647,48.647,0,0,1,48.655,48.655v190.3a48.637,48.637,0,0,1-48.655,48.655",
    transform: "translate(-4165 1117.771)",
    fill: "#fd9f00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    width: 39.236,
    height: 172.532,
    transform: "translate(-3807.67 1189.946)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M124.232,176.036A22.728,22.728,0,0,1,110.7,180.3c-8.966,0-13.927-5.253-13.927-14.823V111.1h30.37V81.382H96.77V38.453H58.9V81.382H40.1V111.1H58.9v54.824c0,29.032,16.634,45.012,46.824,45.012,11.895,0,22.38-2.828,29.5-7.94l.8-.563-10.466-27.412Z",
    transform: "translate(-3801.525 1151.504)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M108.547,42.866c-20.217,0-40.152,5.585-53.324,14.964l-.876.634L68.234,85.493l1.2-.966c8.574-6.813,21.746-11.049,34.355-11.049,17.3,0,26.315,7.235,26.818,21.515H103.787c-34.587,0-53.626,13.4-53.626,37.747,0,22.853,18.818,38.189,46.814,38.189,16.312,0,28.63-4.871,35.915-14.179v14.209h35.6V98.283c0-36.257-20.74-55.417-59.946-55.417m22.078,75.262v10.979c-3.723,9.872-12.75,15.527-24.816,15.527-11.522,0-18.677-5.182-18.677-13.474,0-3.23,0-13.032,20.5-13.032Z",
    transform: "translate(-3710.386 1191.5)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M136.165,82.869c-14.612,0-26.536,4.357-35.462,12.911V38.451H62.835V210.983H99.122V197.106c8.886,9.188,21.324,13.847,37.042,13.847,36.5,0,61.989-26.345,61.989-64.041s-25.49-64.042-61.989-64.042m23.678,64.042c0,19.442-11.975,32.514-29.807,32.514-17.812,0-29.787-13.072-29.787-32.514S112.225,114.4,130.036,114.4c17.832,0,29.807,13.072,29.807,32.514",
    transform: "translate(-3595.521 1151.486)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M143.165,42.866c-38.431,0-66.306,26.939-66.306,64.021,0,37.706,29.123,64.052,70.834,64.052,22.29,0,39.538-6.793,51.241-20.146l.755-.855-20.428-22.169-.936.875c-8.372,7.91-17.54,11.452-29.716,11.452-17.178,0-29.505-8.181-33.3-21.968H207.1l.091-1.147.232-2.737c.242-2.405.453-4.9.453-6.883,0-37.978-26.607-64.494-64.706-64.494m28.63,52.127H114.747c2.848-14.159,13.716-22.884,28.63-22.884,14.773,0,25.54,8.725,28.418,22.884",
    transform: "translate(-3468.42 1191.5)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M168.841,44.071h-1.248c-17.721,0-31.689,5.374-40.675,15.6V42.733H90.631V172.185H128.5v-60.67c0-21.122,11.049-32.755,31.155-32.755,2.214,0,4.126.161,6.36.352l2.828.211Z",
    transform: "translate(-3343.603 1190.294)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M157.026,42.866c-20.237,0-40.152,5.585-53.324,14.964l-.9.634,13.907,27.029,1.2-.966c8.574-6.813,21.726-11.049,34.355-11.049,17.3,0,26.315,7.235,26.818,21.515H152.266c-34.587,0-53.626,13.4-53.626,37.747,0,22.853,18.818,38.189,46.813,38.189,16.312,0,28.63-4.871,35.915-14.179v14.209h35.6V98.283c0-36.257-20.74-55.417-59.946-55.417M179.1,118.128v10.979c-3.723,9.872-12.75,15.527-24.816,15.527-11.522,0-18.687-5.182-18.687-13.474,0-3.23,0-13.032,20.509-13.032Z",
    transform: "translate(-3271.017 1191.5)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 37.867,
    height: 129.452,
    transform: "translate(-3040.359 1233.026)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M149.437,38.452H117.98l-6.219,36.076h23.065Z",
    transform: "translate(-3152.101 1151.494)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M93.251,47.378c0,5.464-4.1,8.886-10.667,8.886H77.654v6.762h-5.7V38.452H82.585c6.571,0,10.667,3.411,10.667,8.926m-5.746,0c0-2.707-1.741-4.287-5.233-4.287H77.654v8.523h4.619c3.492,0,5.233-1.57,5.233-4.237",
    transform: "translate(-3512.838 1151.495)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M91.588,63.027l-4.73-6.853H81.626v6.853H75.94V38.453H86.567c6.581,0,10.677,3.411,10.677,8.926A8.01,8.01,0,0,1,92.2,55.138L97.7,63.027ZM86.265,43.092H81.626v8.554h4.639c3.462,0,5.233-1.6,5.233-4.267,0-2.707-1.771-4.287-5.233-4.287",
    transform: "translate(-3476.749 1151.504)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M98.988,58.458v4.569H79.969V38.453H98.535v4.569H85.624v5.323H97.005v4.438H85.624v5.676Z",
    transform: "translate(-3440.237 1151.504)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M89.45,43v6.5h11.381v4.549H89.45v8.956H83.774V38.455H102.34V43Z",
    transform: "translate(-3405.749 1151.519)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M106.485,58.458v4.569H87.466V38.453h18.576v4.569H93.121v5.323H104.5v4.438H93.121v5.676Z",
    transform: "translate(-3372.29 1151.504)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    "data-name": "Rectangle 507",
    width: 5.676,
    height: 24.554,
    transform: "translate(-3246.531 1189.966)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M101.472,43.092H93.6V38.453h21.414v4.639h-7.869V63.027h-5.676Z",
    transform: "translate(-3316.673 1151.503)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M97.436,52.209V38.453h5.676V52c0,4.669,2.053,6.6,5.494,6.6,3.462,0,5.464-1.932,5.464-6.6V38.453h5.605V52.209c0,7.235-4.146,11.24-11.12,11.24s-11.12-4.005-11.12-11.24",
    transform: "translate(-3281.928 1151.504)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M117.316,63.027l-4.73-6.853h-5.233v6.853h-5.686V38.453h10.627c6.581,0,10.677,3.411,10.677,8.926a8.01,8.01,0,0,1-5.042,7.759l5.515,7.889Zm-5.323-19.935h-4.639v8.554h4.639c3.462,0,5.233-1.6,5.233-4.267,0-2.707-1.771-4.287-5.233-4.287",
    transform: "translate(-3243.573 1151.504)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M124.769,57.754h-11.4l-2.174,5.273h-5.817l10.928-24.574h5.635L132.92,63.027h-5.988Zm-1.791-4.317-3.884-9.4-3.894,9.4Z",
    transform: "translate(-3209.958 1151.504)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M8.944,110.719H77.061V42.058l-12.81-.07c-3.16,1.147-14.783,5.344-23.356,6.662l-3.955.282c-6.793,0-13.947-2.184-17.862-3.623L7.7,57.374a201.612,201.612,0,0,1,4.74,27.1c.815,9.208-1.58,19.693-3.492,26.245",
    transform: "translate(-4095.25 1183.542)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M55.1,113.574c.191-.07,18.3-7.8,26.818-25.963,8.151-17.349,3.653-35.14,3.22-36.67l-.533-1.58H14.972v73.923a37.947,37.947,0,0,1,15.7-4.6A96.074,96.074,0,0,0,55.1,113.574",
    transform: "translate(-4029.307 1250.364)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M12.255,164.606c9.681,20.639,29.706,29.193,30.582,29.575A104.189,104.189,0,0,0,69.6,199.836a30.715,30.715,0,0,1,17.127,6.36l1.791,1.389,1.65-1.369a30.7,30.7,0,0,1,17.107-6.6,100.66,100.66,0,0,0,26.728-5.978c.845-.352,20.78-9.117,30.23-29.857s3.391-41.047,3.13-41.893l-.02-.121c-.07-.161-6.5-17.228-5.323-30.471a208.184,208.184,0,0,1,5.253-29.052l.231-.9L150.643,43.466l-1.087.493c-.141.05-12.77,5.535-21.777,4.146-9.328-1.439-23.155-6.712-23.3-6.762l-.312-.111-33.218.181-.292.121c-.141.05-13.9,5.494-23.226,7.024-9.006,1.479-21.686-3.864-21.827-3.915L24.5,44.17,7.847,62.224l.262.916a211.153,211.153,0,0,1,5.585,28.982c1.318,13.2-4.931,30.35-5.021,30.632-.262.855-6.078,21.233,3.582,41.852m-.332-40.836c.493-1.338,6.531-18.264,5.132-32a210.2,210.2,0,0,0-5.414-28.6L25.4,48.226c3.492,1.338,14.169,5.062,22.6,3.7C57,50.42,69.464,45.66,71.607,44.8l31.95-.161c2.174.805,14.682,5.444,23.709,6.833,8.433,1.3,19.09-2.546,22.521-3.935l13.958,14.773a213.179,213.179,0,0,0-5.122,28.68c-1.218,13.736,5,30.612,5.515,31.93.312,1.077,5.706,20.327-2.989,39.437-8.906,19.512-28.3,28.066-28.468,28.136a99.276,99.276,0,0,1-25.7,5.706,34.664,34.664,0,0,0-18.5,6.994l-.05-.02v.02a34.382,34.382,0,0,0-18.546-6.783,100.589,100.589,0,0,1-25.751-5.394c-.191-.1-19.673-8.433-28.791-27.855-8.886-18.969-3.723-38.31-3.421-39.4",
    transform: "translate(-4104.288 1176.69)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M20.995,51.1l.05-.594L20.8,46.555l-.654-1.389.161,1.087.262,2.918L20.4,53.72l-.181,1.771L20.9,58.1l.755,1.208v-.262L21.367,56.2Z",
    transform: "translate(-3982.384 1212.344)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M79.609,84.5a198.32,198.32,0,0,1,4.74-27.13L72.968,45.337c-4.689,1.7-14.048,4.549-21.827,3.341-8.594-1.318-20.187-5.5-23.346-6.692l-12.82.07v68.691H83.091c-1.9-6.571-4.307-17.037-3.482-26.245m-9.167,6.853-.372,1.439-.594-1.912.05,1.087.07,3.2.231,2.244-.352.795-.07.242.02.9-.543.634-2.516.161-.523-.684.332-.886.664-1.067.3-1.057-.634-4.9-.775-1.65-1.54-2.073-.916-1.157-.543.091v1.509L63,91.828l-.473,1.439-.4,1.077-.091,3.935.091.4-.533.594-.221.211-.111.7-.493.473-2.365.091-.3-.07-.423-1.006.946-1.4,1.107-2.757-.433-5.112-.936-2.757-.262-.091-1.811.755-2.244,1.338-.725.543-1.369-.04-.875-.805-1.721-.735-1.831-.463L45.2,88.2l-.4.262-.614.986-.392,1.318L43.3,92.583l-.081,2.546.151.654.322,1.912-.211.845-.443.262-.382.211-1.53,1.248-1.369-.02-.443-.121L39,99.154,39.971,98l.875-1.972.121-1.791-.211-3.21-.141-.916-.875-.191-.986-.3-.382.181-.121,4.981.4,2.073-.111.634-.614.372L37.737,98l-.231.875-.594.493-1.932.141-.523-.07-.423-.946,1.036-1.359.614-1.681.03-2.3-.332-2.808-.211-1.862-.523-.513L32.5,86.9l-1.58-2.073-1.268-3.059-.211-1.107-.493-1.107-1-.523-.986-.111-1-1.107-.02-.664-.191-1.721L25.58,73.4l-1.208.493H22.914l-.473-.845.664-1.177,1.036-.755.775-.262.332-.282-.191-.423-.473-.1-2.355-3.582.1-.231.181.161,1.137,1.459,2.405.543,1.318-.141,1.791-.161,1.429.262h1.56l1.409-1.107.684-.966.171-.121.091.211-.07,1.016-2.214,2.546-.262.111L35.07,69l1.892-1.811,3.2-1.721,2.5,1.65.191.845,3.18,3.25h4.337a68.084,68.084,0,0,1,6.742-1.268l4.78.181,2.234.352,1.016.453,1.389.584,1.791,1.681.594,2.868.231,4.438.211,3.432.05,1.932.775,3.069Z",
    transform: "translate(-4029.289 1183.524)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M15.876,49.776V48.387l-.262-.453-1.882-1.107h-.4l-2.5,1.459-.05.362.594.6,4.1,2.194.423-.352Z",
    transform: "translate(-4067.267 1227.399)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M10.85,48.768l2.425,1.389h.493l1.419-.8.493-.9-.02-1.036V46.011l-.312-.282L10.8,48.345Z",
    transform: "translate(-4067.126 1217.447)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M16.457,48.164l-2.335-1.338-.493.02-1.53.9-.594,1.016.03,1.006v1.459l.3.262,4.74-2.828Z",
    transform: "translate(-4060.721 1227.387)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M13.711,49.087V48.051L13.48,47.6l-2.455-1.389-.352.121-.02,5.515.392.141,1.56-.9Z",
    transform: "translate(-4068.461 1221.8)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M11.783,49.255l1.7.946h.443l2.5-1.469.05-.372-.916-.9-3.824-1.741L11.5,46v2.848Z",
    transform: "translate(-4060.764 1217.389)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M14.4,46.207l-1.459.845-1.107,1.791v1.208l.282.473,2.425,1.409.423-.191-.091-5.374Z",
    transform: "translate(-4057.754 1221.778)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M15.6,48.477l-2.214-2.194L11.175,48.5l2.234,2.264Z",
    transform: "translate(-4063.717 1222.475)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M34.616,43.331,8.814,90.688l52.117-.3Zm12.3,33.621,1.489.634.231.473L48.4,79.075l-.453.3-1.7-.121-.392.262-.03.03-.372.986.725.755.755.725.05.382-.614.946-.493.141-1.53-.664-.594.121-.211,1.67.473.875-.121.584-.755.594-.584-.03-1.278-1.127-.513-.05-.141.1-.634,1.358.181,1.047-.252.463-1.016.382-.473-.171-.805-1.459-.513-.262L35.934,88l-.211,1.067-.4.352h-.845l-.644-.543-.282-1.489-.352-.322-1.53.7-.473.825-.543.211-.845-.262-.372-.614.211-1.439-.312-.614-1.509.171-.725.684-.564.02L25.68,86.1l-.091-.5.7-1.429-.07-.543-1.62-.352-1.107.392-.735-.9.07-.795,1.016-.966.111-.493-1.409-.926-.614.03-.805-.594.684-1.479.523-.262.473-.7-.9-1.117-1.248-.322-.03-1.087.05-.231.584-.574,1.016-.091.735-.634L23.134,72l-.211-.493L21.8,70.8l-.211-.684.091-.211,1.439-.775,1.65-.664-.02-.584-.9-1.117.02-.564.211-.262,1.63-.231L27.5,65.57l.141-.513-.4-1.187.3-.845,1.016-.493.775.845,1.419.423.141-.04.473-.664V61.756l.3-.382.875-.181h.543l.322.886,1.53,1.067h.121l.312-.242.564-1.741.845-.02.543.121.4.493V63.2l.3.423,1.842-.523,1.6-.372.282.141.211.473-.473,1.55.141.473.262.191,1.419.04.865-.584.453.02.795.805.03.493-.966,1.3-.03.584,1.65.664,1.7.825-.161.684-1.3.9-.171.443.05.141,1.348,1.107,1.338,1.318-.423.574-1.509.443-.332.382-.04.916Z",
    transform: "translate(-4085.118 1195.714)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M39.128,113.593A97.229,97.229,0,0,0,63.561,118.7a38.112,38.112,0,0,1,15.668,4.569V49.36H9.6l-.543,1.6c-.4,1.509-4.9,19.3,3.23,36.67,8.5,18.144,26.647,25.872,26.838,25.963M73.785,84.259l-4.337,3.9-3.623.926a7.78,7.78,0,0,1-5.756-2.214l-1.57-1.56-6.461-.05-2.214,2a8.263,8.263,0,0,1-10.295-.141l-1.721-1.57c-2.284-2.123-4.669-2.083-6.883.111l-2.335,2.174a7.8,7.8,0,0,1-8.715.372l-3.965-3.653.05-.614,2.214-1.862.7.171,2.385,2.355,5.8-.4,3.3-2.878a8.356,8.356,0,0,1,9.8,1.228l2.023,1.811,5.253.03,2.194-2,5.444-2.264,4.287,1.087,2.777,2.355,2.647,1.691,3.955-1.218,2-2.1.875-.091,2.043,1.691ZM15.892,73.511l2-1.67.986.091,2.385,2.355,5.625-.332,2.385-2.284a8.136,8.136,0,0,1,10.415.242l1.771,1.62,6.4.07,3.12-2.657a8.255,8.255,0,0,1,9.63.9L62.475,73.6l6.038.262,2.113-2.214.946-.07,2.023,1.67.121.614a13.474,13.474,0,0,1-5.233,4.357l-2.707.574a8.191,8.191,0,0,1-5.917-2.405L58.5,75.021H51.878l-2.244,2a8.358,8.358,0,0,1-9.027.543l-2.476-2-1.389-1.177-5.233.352-2.938,2.727a8.017,8.017,0,0,1-9.449-.07L15.8,74.216Z",
    transform: "translate(-4097.409 1250.355)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M18.285,51.02c-.4,2.143-.875,4.287-1.3,6.43l.594.875c2.234.443,4.428.9,6.662,1.338,2.244.473,4.478.926,6.722,1.369l.543-.564c-.735-2.526-1.509-5.021-2.264-7.537l-.684-.594c-3.14-.634-6.269-1.248-9.4-1.932Z",
    transform: "translate(-4011.045 1259.835)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M27.415,81.522l-1.157-.563-.795-1.228L24.5,76.359l-.966-1.2-1.862-.755.252-1.3q1.887-9.253,3.774-18.516l.755-3.653-.543-.644-.443.574-1,4.871Q22.6,64.933,20.723,74.1l-.3-.091-.805.091-1.348.382L17,76.46l-.091.372-.1,2.355.121.07-.875.664.312,1.338.473.282v.03l-.191,1.691,1.228.785.755.352-.9,4.307-1.278,6.34.332.684.614-.493.091-.4q1.026-5.027,2.053-10.063l.805.262,2.023.916.7.755,1.208-2.616Z",
    transform: "translate(-4019.501 1258.838)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M17.535,54.99l.594.523.654-.292,1.036-1.057.191-.614-.564-2.657-.171-1.187-.161.1-2.174,3.25v.513Z",
    transform: "translate(-4011.457 1253.496)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M26.64,54.112l-1.036.564-2-.9s-1.419.262-3.7,3.019a9.31,9.31,0,0,0-2.214,5.444s4.569,3.059,6.974,4.569l.735.352H28.22l.584-.352,7.376-5.635Z",
    transform: "translate(-4004.728 1290.414)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M21.789,54.511a10.748,10.748,0,0,0-2.455,5.112l9.268,6.9,4.549-1.157L27.425,52.277s-3.562-.1-5.635,2.234",
    transform: "translate(-3989.774 1276.783)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M21.007,54.874A6.675,6.675,0,0,0,18.633,59.8L28.877,67.03l3.16-2.616,2.093-3.9-9.349-7.427s-1.3-.332-3.774,1.791",
    transform: "translate(-3996.137 1283.926)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M20.811,55.412l-.684,1.741L18.6,58.29l-.382.372.523.262c6.6,1.338,8.1,1.58,14.7,2.918l-6.289-4.005.05-.091c3.814.282,5.132.231,8.926.543.02-.07-5.374-2.405-8.433-3.824l.02-.091,3.462-1.036c-.141-.232-5.837-1.3-11.14-2.385l-.423.453Z",
    transform: "translate(-3999.916 1264.802)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M21.815,52.237l-3.462-.8-.352.4.845,2.073.614.141,2.284-1.55Z",
    transform: "translate(-4001.857 1269.131)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M30.3,56.334l-8.956-2.878-3.27,2.405-1.248,3,7.8,5.726L27,59.323Z",
    transform: "translate(-4012.522 1287.481)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M5.389,50.026l.332-.664-.453-.3-.443.05-.242.3.05.211Z",
    transform: "translate(-4123.451 1247.639)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M11.59,52.008l-.121-.161-5.957-.121L4,55.449l.423,1.982.171.211.352-.825a7.918,7.918,0,0,1,6.34-4.689Z",
    transform: "translate(-4128.729 1271.799)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M6.071,53.693l.9-.161.664-.9-.453-1.177-.473-.141-1.318.211-.443.322.091,1.489Z",
    transform: "translate(-4120.191 1268.099)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M6.312,53.645l.946-.161.634-.875L7.8,51.874l-.735-.6L5.557,51.5l-.3.262.02,1.53Z",
    transform: "translate(-4117.371 1267.669)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M5.725,53.578l.946-.161.654-.926L6.9,51.384l-2.264.352.1,1.489Z",
    transform: "translate(-4122.964 1268.702)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M6.252,53.226l.966-.161.634-.855-.4-1.177-2.234.312.02,1.509Z",
    transform: "translate(-4117.732 1265.51)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M6.352,53.882l.875-.141.7-1.016-.07-.493-.946-.7-1.2.191L5.3,52l.04,1.53Z",
    transform: "translate(-4117.01 1269.995)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M6.009,53.419l.875-.141.282-.07.372-1.419-.825-.725-1.389.211-.423.3.121,1.509Z",
    transform: "translate(-4120.574 1265.798)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M5.321,52.941l1.338-.211.382-.231L6.78,50.657l-.141-.05-1.952.312-.171,1.459Z",
    transform: "translate(-4124.073 1261.654)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M5.969,53.119l.946-.161.684-.9-.03-.07L6.089,50.815l-.684.111-.543.332.121,1.51Z",
    transform: "translate(-4120.939 1263.539)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M5.556,52.912l1.489-.231.372-.292-.121-1.5-.936-.332-.926.141-.372.141-.242,1.389Z",
    transform: "translate(-4121.306 1261.205)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M6.657,50.508l-.966.161-.282.1-.282,1.409.725.684,1.509-.211.352-.282-.07-1.489Z",
    transform: "translate(-4118.533 1260.756)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M6.963,50.459l-1.016.161-.231.1L5.433,52.13l.725.7L7.667,52.6l.352-.282-.07-1.489Z",
    transform: "translate(-4115.759 1260.319)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M6.109,53.074l1.127-.191.684-.966L7.5,50.81l-.091-.04-2.073.3-.171.262.262,1.509Z",
    transform: "translate(-4118.207 1263.129)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M5.665,53.1l.875-.141.564-.3-.262-1.791-2.284.372.091,1.53Z",
    transform: "translate(-4123.689 1264.032)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M7.252,53.024l-.05-1.53-.986-.382-.946.171-.684.936.4,1.137Z",
    transform: "translate(-4123.445 1266.235)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M6.963,50.715l-.845.141-.262.07-.382,1.53.9.614,1.137-.161L8,52.627v-1.54Z",
    transform: "translate(-4115.39 1262.634)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M7.83,52.486l-.664-.7-1.53.232-.3.241.04,1.55,1.016.332L7.307,54l.5-.594Z",
    transform: "translate(-4116.655 1272.307)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M6.756,50.251l-1.228.211-.111.02-.332,1.469.825.7,1.177-.191.473-.332-.312-1.721Z",
    transform: "translate(-4118.909 1258.434)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M5.592,52.655l1.389-.211.4-.382-.161-1.429-1-.332-.634.091-.262.07-.543,1Z",
    transform: "translate(-4121.618 1258.873)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M6.715,50.209l-.634.091-.262.07-.443,1.54.966.654.886-.141.543-.3-.04-1.58Z",
    transform: "translate(-4116.267 1258.054)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M5.636,52.552l.755-.121L6.9,52.11l-.282-1.751-2.113.332.07,1.489Z",
    transform: "translate(-4124.136 1259.407)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M6.923,52.184l.231-.191-.282-1.811-.543-.141-.966.161-.6.825.02.05Z",
    transform: "translate(-4121.86 1256.526)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M7.064,50.12,6.5,50l-.9.141-.564.543.231,1.389.473.282,1.318-.181.3-.241Z",
    transform: "translate(-4119.309 1256.15)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M5.332,52.459l1.157-.191.332-.231L6.56,50.225l-.4-.141-1.177.181-.493.543.231,1.318Z",
    transform: "translate(-4124.334 1256.922)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M5.817,50.1l-.211.07L5.324,51.7l.845.614,1.036-.161.382-.262L7.276,50.1l-.493-.141Z",
    transform: "translate(-4116.746 1255.754)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M7.464,52.409l-.4-.372-1.248.181-.443.332.322,1.741.594.121,1.157-1.248Z",
    transform: "translate(-4116.327 1274.61)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M5.514,51.4l.282,1.67.825.141.845-.7.382-1.157-.1-.372Z",
    transform: "translate(-4115.027 1265.044)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M5.526,51.887l.875-.141.584-.7-.02-.282-1.278-.946-.533.07-.4.262.3,1.62Z",
    transform: "translate(-4121.941 1254.474)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M5.571,51.843l.231-.02.785-1.771L6.4,49.86l-1.912.382.141,1.318Z",
    transform: "translate(-4124.358 1254.89)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M6.564,49.766l-1.228.191-.332.3.141,1.348.946.282.191-.05.875-1.63Z",
    transform: "translate(-4119.645 1254.038)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M5.533,49.918l-.262.211.07,1.389.926.312.161-.03.946-1.6-.523-.473Z",
    transform: "translate(-4117.226 1253.676)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M6.438,51.207l-.262-1.58-1.691.262.231,1.58Z",
    transform: "translate(-4124.347 1252.776)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M4.725,49.919l.141,1.369.9.262.121-.03L6.658,49.8,6.5,49.587Z",
    transform: "translate(-4122.172 1252.41)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M6.153,49.538l-.805.141-.372.211.211,1.63.473.111.825-.111.211-.1.231-1.359Z",
    transform: "translate(-4119.901 1251.97)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M5.355,51.182l.9.262H6.3l.916-1.6-.231-.332-1.771.332Z",
    transform: "translate(-4117.747 1251.728)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M6.971,54.247l.07-1.7-.262-.252-.372.07-1,1.741.262.352,1.177.091Z",
    transform: "translate(-4115.96 1276.954)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M5.247,50.682l.735.231.231-.02L6.847,49.5l-.141-.191-1.55.282Z",
    transform: "translate(-4118.266 1249.929)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M6.44,50.682l-.191-1.3-1.53.241.191,1.268Z",
    transform: "translate(-4122.232 1250.576)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M4.646,51.01,6.156,50.8l-.02-1.127-.684-.262-.362.04-.584,1.419Z",
    transform: "translate(-4124.167 1250.808)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M6.494,49.348l-1.56.332.121,1.057.7.211.191-.02.755-1.278Z",
    transform: "translate(-4120.277 1250.249)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M4.729,52.045l1.63,1.53.423-.091-.312-1.721-.443-.141L4.8,51.813Z",
    transform: "translate(-4122.145 1270.855)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M5.441,53.757l.443.946.473.111.171-.423.111-1.55-.282-.282Z",
    transform: "translate(-4115.691 1279.35)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M5.913,50.463l-.191-1.248-1.177.211.191,1.2Z",
    transform: "translate(-4123.81 1249.043)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M5.281,50.541l1.157-.211-.171-1.2-1.177.161Z",
    transform: "translate(-4118.873 1248.292)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M4.908,49.322,5.1,50.57l1.147-.211-.161-1.2Z",
    transform: "translate(-4120.518 1248.549)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M6.094,50.416l-.211-1.228-1.157.191.191,1.228Z",
    transform: "translate(-4122.169 1248.796)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M6.247,53.166l.372-1.63-.282-.3-.775.332.161,1.761Z",
    transform: "translate(-4114.58 1267.339)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M5.771,49.817l-.141-.775-.9.161.141.755Z",
    transform: "translate(-4122.087 1247.476)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M6.011,49.774,5.921,49l-.9.111.091.785Z",
    transform: "translate(-4119.457 1247.085)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M5.868,49.795l-.091-.775-.9.141.091.775Z",
    transform: "translate(-4120.758 1247.274)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M28.189,45.865l-.05-10.576-2.989.02.02,5.464H22.6l-.05-5.464-2.989.02.05,5.474-2.6.02L17,35.359H14l.07,10.576Z",
    transform: "translate(-4038.118 1122.825)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M32.739,41.823l-2.546-1.58-2.9,4.619L22.917,42.1l2.918-4.619-2.546-1.6-5.605,8.976L27.1,50.779Z",
    transform: "translate(-4004.723 1128.236)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M25.341,44.812l-5.726-8.886-2.526,1.6,2.969,4.6L15.7,44.932l-2.938-4.6-2.526,1.63,5.726,8.876Z",
    transform: "translate(-4072.226 1128.602)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M31.86,38.274l-2.918-.614L27.8,42.983l-2.546-.513,1.157-5.354L23.5,36.482,22.36,41.836l-2.546-.543,1.157-5.354-2.918-.614L15.839,45.67l13.827,2.949Z",
    transform: "translate(-4021.445 1123.156)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M28.068,45.665l-2.3-10.325L22.835,36l1.208,5.323-2.526.564-1.2-5.323-2.928.664L18.6,42.555l-2.526.564-1.2-5.323-2.9.634,2.3,10.325Z",
    transform: "translate(-4056.449 1123.291)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M12.664,38.6l-.231,8.322a71.528,71.528,0,0,1,13.474-2.6l-3.985-7.8Z",
    transform: "translate(-4052.319 1134.04)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M25.574,36.453,16.1,36.5l-2.073,8.272c2.214-.171,4.5-.262,6.853-.292,2.335,0,4.619.05,6.853.191Z",
    transform: "translate(-4037.827 1133.378)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M28.828,38.492,19.539,36.51l-3.884,7.869a71.078,71.078,0,0,1,13.5,2.435Z",
    transform: "translate(-4023.117 1133.895)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M28.446,40.421l-5.494-3.442-5.726,6.34a21.161,21.161,0,0,1,8.161,4.619Z",
    transform: "translate(-4008.879 1138.145)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M16.548,37.013l-5.464,3.512,3.16,7.5c1.64-1.791,4.448-3.4,8.1-4.74Z",
    transform: "translate(-4064.545 1138.453)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M36.713,39.866c-13.5.07-24.433,2.113-24.413,4.589,0,2.476,10.959,4.408,24.463,4.337C50.288,48.7,61.217,46.648,61.2,44.173c0-2.445-10.959-4.377-24.484-4.307m17.651,5.062c0,1.338-7.869,2.455-17.6,2.5-9.711.07-17.6-.966-17.631-2.3,0-1.318,7.869-2.455,17.61-2.5,9.731-.07,17.62.986,17.62,2.3",
    transform: "translate(-4053.524 1164.29)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M67.555,47.886C67.534,42.935,55.066,39,39.7,39.071c-15.336.1-27.754,4.176-27.734,9.117l2.476,3.683-.654-1.137c0-2.828,11.613-5.182,25.963-5.253,14.35-.091,25.993,2.143,26.013,4.971l-.634,1.137Z",
    transform: "translate(-4056.551 1157.095)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M77.682,46.933c-1.63-5.444-15.859-9.61-33.178-9.52s-31.528,4.428-33.077,9.892l.966,3.442,3.321-3.623-.493-1.489,4.921-1.691.282.795a48.375,48.375,0,0,1,6.179-1.9l-.191-.855,6.34-1.439.231,1.137c2.546-.352,5.213-.594,7.99-.7V39.184l7.094-.03v1.771c2.777.091,5.464.3,7.98.614l.242-1.137,6.36,1.369-.191.875a47.7,47.7,0,0,1,6.2,1.811l.262-.795,4.971,1.67L73.4,46.812l3.371,3.562Z",
    transform: "translate(-4061.436 1142.068)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M18.377,38.164A48.505,48.505,0,0,0,12.389,39.9l.875,2.546L18.97,40.78Z",
    transform: "translate(-4052.717 1148.885)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M22.567,38.527c-2.385-.282-4.9-.473-7.5-.543V40.62c2.405.1,4.74.262,6.933.523Z",
    transform: "translate(-4028.419 1147.254)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M21.116,37.987c-2.6.121-5.112.332-7.5.634l.594,2.616c2.214-.282,4.518-.493,6.923-.584Z",
    transform: "translate(-4041.57 1147.281)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M15.125,38.56l-3.562,3.23.9,3.16,3.562-3.794Z",
    transform: "translate(-4060.203 1152.479)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M22.948,39.816a48.892,48.892,0,0,0-5.988-1.67L16.4,40.762l5.706,1.6Z",
    transform: "translate(-4016.393 1148.722)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M21.894,41.711l-3.582-3.18-.875,2.586,3.613,3.754Z",
    transform: "translate(-4006.972 1152.208)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M71.285,52.269l1.459-5.394L68.93,43.524l-.352,1.067-4.971-1.65.493-1.509-5.494-1.489-.372,1.751-6.36-1.369.3-1.419c-2.053-.231-4.216-.372-6.461-.443v1.721l-7.084.04V38.482c-2.244.1-4.408.282-6.46.543l.3,1.419-6.31,1.429-.4-1.761-5.484,1.55.493,1.509-4.931,1.7-.372-1.067-3.774,3.421L13.2,52.6h.05l-.141-.9c-.03-5.182,13-9.469,29.072-9.57,16.091-.091,29.153,4.055,29.193,9.238l-.141.9Z",
    transform: "translate(-4059.043 1151.586)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M24.166,52.159l.231.262.121.916.211.9.312.825.423.735.493.634.584.493.664.372.352.151.191.07.161.04h.03v-.04l-.03-.966-.141-1-.091-.443-.161-.453-.4-.795-.543-.644-.664-.443-.725-.282-.382-.07h-.191l-.181-.03-.262-.252-.614-.644.312.332Z",
    transform: "translate(-3951.545 1269.708)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M24.374,54.087l.161.916.262.855.4.775.473.684.543.564.3.211.161.121.171.091.02-.05.141-.986.03-1.016-.03-.493-.07-.493-.231-.9-.423-.805-.543-.634-.634-.473-.362-.161-.181-.091-.171-.05-.181-.332L23.74,51h-.03l.242.423.231.433.191.322-.05.966Z",
    transform: "translate(-3950.113 1265.195)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M27.458,56.9l.161.05h.03v-.03l.02-.986-.07-.986-.091-.473-.121-.453-.352-.825-.493-.684-.644-.493-.674-.322-.382-.1-.161-.02-.191-.03-.211-.282-.594-.684.282.362.292.352.211.282.07.916.161.916.262.855.372.755.453.684.564.533.614.433.332.161Z",
    transform: "translate(-3950.348 1261.416)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M27.024,57.062l.161.07h.03v-.02l.111-1.016V55.11l-.07-.5-.07-.463-.3-.9-.453-.755-.564-.594-.654-.443-.352-.141-.221-.05-.161-.05-.191-.322-.513-.785.262.4.231.4.191.332v.936l.091.946.191.9.3.825.423.755.5.634.584.523.312.211Z",
    transform: "translate(-3949.539 1257.142)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M25.587,52.6l-.473.845-.4.926-.282.966-.161.966-.07.986.02.473.03.231.02.242v0h.02l.684-.614.121-.141.091-.1.121-.111.161-.191.07-.07.1-.121.282-.4.262-.423.423-.936.282-1.016L27,53.1l-.04-1.016-.07-.463-.05-.242-.05-.231.1-.423.262-1.107-.121.564-.141.543-.121.423-.614.684Z",
    transform: "translate(-3945.685 1252.653)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M27.3,56.167v-.05l.07-.936-.02-.966-.07-.453-.1-.443-.3-.825-.453-.714-.564-.533-.654-.382-.362-.121-.161-.07-.161-.02-.211-.282-.523-.735.262.382.262.352.181.3.03.9.111.9.211.855.312.775.423.684.493.584.594.453.3.191.171.091Z",
    transform: "translate(-3949.416 1252.859)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M24.662,52.972l-.262.9-.161.946-.05.9.05.916.05.423.04.211.05.211.02-.02.543-.684.091-.121.07-.111.1-.141.121-.191.04-.1.07-.111.242-.423.181-.453.292-.916.141-.966v-.966l-.121-.9-.121-.423L26,50.758l-.091-.191.07-.4.121-1.057-.07.523-.05.533-.07.4-.473.735-.423.795Z",
    transform: "translate(-3945.768 1248.066)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M27.335,52.918l-.121-.423-.322-.775-.453-.664-.594-.493-.654-.332-.352-.091-.191-.03-.161-.02-.191-.262-.543-.684.262.332.262.352.211.282.04.876.141.845.242.805.352.755.423.614.523.543.584.423.312.161.161.07.161.05v-.03l.05-.936-.07-.926Z",
    transform: "translate(-3949.732 1248.399)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M24.311,55.053l.231.775.171.352.07.171.121.161.02-.02.4-.805.322-.845.121-.453.121-.463L25.981,53l-.091-.9-.211-.825-.332-.755-.191-.3-.111-.161-.121-.141-.05-.382-.091-.966.05.493.04.473.03.4-.332.805-.242.865-.161.875-.05.865.05.875Z",
    transform: "translate(-3946.402 1243.222)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M24.208,49.32l.211.262.07.825.141.825.242.775.352.684.423.584.513.523.574.4.3.141.141.07.161.04v-.04l.03-.875-.07-.865-.1-.433-.111-.423-.332-.725-.453-.614L25.737,50l-.634-.312-.352-.091-.171-.02-.161-.03-.191-.252-.543-.644.262.332Z",
    transform: "translate(-3950.347 1243.974)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M24.089,52.608l.211.3.05.926.161.916.262.875.352.775.473.684.543.584.634.453.332.161.161.07.191.07v-.04l.05-1L27.43,56.4l-.07-.473-.111-.473-.352-.825-.5-.7-.634-.513-.684-.362L24.7,52.94l-.191-.03-.191-.02-.211-.282-.584-.735.282.362Z",
    transform: "translate(-3951.783 1273.137)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M30.057,52.848l-.352.332-.312.262-.7.091-.725.211-.735.3-.7.453-.664.543-.614.634-.543.735-.231.372-.121.211-.091.191v.02h.02l.735.03.755-.121.372-.121.382-.141.755-.423.684-.594.584-.725.493-.8.191-.443.091-.211.1-.211L29.7,53.2l.725-.684Z",
    transform: "translate(-3945.124 1278.96)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M29.973,52.483l-.352.352-.282.282-.7.171-.735.252-.735.382-.684.513-.634.594-.564.684-.493.755-.211.4-.121.211-.091.211h.04l.735-.05.755-.191.372-.141.382-.161.725-.493.664-.664.543-.755.443-.845.191-.423.07-.211.07-.242.262-.262.7-.725Z",
    transform: "translate(-3944.156 1275.464)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M210.964,84.932l-.332.382-.262.3-.725.211-.7.332-.714.443-.654.543-.614.664-.543.724-.443.785-.191.393-.05.121h-.191c.966-3.321,1.58-5.766,1.58-5.766l-.282,1.057.594-2.476,1.057-5.535.614-5.565.07-5.555v-.07l.282-.644.262-.795.091-.423.05-.4.02-.805-.111-.755-.262-.654-.382-.574-.231-.252-.121-.1-.111-.091-.05-.312-.171-.795h-.02l.091.4.07.392.081.312-.121.282-.03-.191-.04.03.04.3-.111.332-.191.775-.091.805v.755l.111.725.211.664.292.614.161.282.091.121.07.07-.141,5.555-.654,5.535-1.107,5.494L205.681,88l-.533,1.831h-.141l-.221.05v-.211l-.07-.845-.231-.785-.02-.02.231-.312.191-.3.07.091.282.191.141.091.161.1v-.05l.191-.865.1-.926v-.423l-.05-.423-.03-.091.05-.241.262-.332.3-.393.05.02.141.091v-.02l.262-.876.161-.916.05-.453v-.423l-.121-.845-.262-.755-.111-.161.332-.493-.312.443-.02.05-.312-.473-.543-.493-.07-.05.292-.7.161-.664.231.614.352.614.453.513.231.221.141.111.141.07v0l.03-.02.211-.845.121-.855.02-.423v-.423l-.141-.805-.312-.674-.423-.594-.111-.121.04-.091-.04.091-.4-.332-.282-.181-.171-.05-.141-.07-.111-.282-.242-.473.191-.775.091-1.016v-.513l-.02-.262-.02-.211.161-.4.332-.916v.02l.141.282-.121.775V71.2l.091.755.171.735.3.634.382.564.443.473.262.211.121.07.141.091h.02v-.04l.191-.825.091-.855v-.392l-.02-.4-.171-.755-.322-.664-.433-.543-.533-.392-.312-.151-.161-.07-.141-.04-.141-.282v-.03l.04-.141-.04.141-.382-.654.191.352.161.332-.111.372-.211.523-.171.423-.684.543-.634.684-.564.755-.493.845-.4.916-.282.946-.171.986-.07.493v.473h.03l.322-.211.121-.07.282-.191.735-.584.332-.352.3-.4.543-.845.372-.966.05-.241.05.091.161.382.121.282-.121.825-.04.825.02.443-.332.171-.7.493-.664.614-.614.724-.513.805-.453.9-.322.946-.121.473-.05.141c.262-3.794.382-6.511.382-6.511l-.1,1.208.141-2.808.05-6.149-.423-6.128-1.037-6.008-.02-.07.181-.735.121-.916.02-.473-.02-.443-.121-.875-.282-.775-.423-.664-.523-.543-.282-.211-.161-.091-.141-.07-.121-.332-.352-.825.171.4.161.423.141.332-.05.332-.07-.211-.07.04.121.312-.07.4-.05.865.07.855.171.825.252.745.352.714.433.584.231.262.141.121.07.07.946,6.008.372,6.1-.111,6.128-.473,6.128c-.352,3.371-.714,6.813-1.248,10.174l-.121-.161.121.161-.362,2.053-.3,1.741-.332-.584.211.372.121.242-.684,3.673-1.721,6.551-.443,1.53-.382-.584-1.62-.735-1.369.282-3.281,2.6-2.566,2.918a87.906,87.906,0,0,0-8.272,12.891c3.16-3.985,6.269-8.01,9.62-11.754l2.586-2.667,2.737-2.023.493-.121.05.05.3,1.177-.282,3.431A29.126,29.126,0,0,1,192.4,117.6a65.261,65.261,0,0,1-3.774,6.471l-.05.07-1.248-1.127-1.479-.211-4.5,1.228-3.935,1.9a100.837,100.837,0,0,0-14.42,9.64c5.042-2.808,10.033-5.635,15.2-8.081l3.884-1.65,3.824-.946.634.1.161.141-.191,1.389-.725,1.67-1.982,2.757-.966,1.036c-7.92,8.061-18.114,13.434-28.841,16.7a113.122,113.122,0,0,1-16.473,3.723c-2.777.423-5.585.785-8.413,1.067-2.828.322-5.766.654-8.624,1.147a118.947,118.947,0,0,0-12.056,2.687,117.069,117.069,0,0,0-17.47-3.27l-4.971-.493-4.85-.564c-3.25-.433-6.461-.966-9.661-1.63a90.888,90.888,0,0,1-18.587-5.776A63.683,63.683,0,0,1,36.45,135.267l-3.462-3.281-2.164-2.918-.755-1.7L29.879,126l.141-.141.634-.091,3.844.9,3.915,1.6c5.162,2.385,10.2,5.162,15.266,7.9a103.726,103.726,0,0,0-14.511-9.449l-3.985-1.892-4.5-1.177-1.459.242-1.258,1.127-.04-.07a67.364,67.364,0,0,1-3.844-6.43,27.682,27.682,0,0,1-2.637-6.793l-.332-3.431.282-1.177.07-.05.473.121,2.777,1.972,2.616,2.647c3.371,3.713,6.531,7.7,9.731,11.663a84.058,84.058,0,0,0-8.413-12.8l-2.586-2.918L22.744,105.2l-1.369-.282-1.6.775-.825,2.405-.03.7-2.445-6.128h.091l1.318-.181.523-.332L20.782,97.8l.1-5.756c-.282-2.687-.714-5.344-.825-8.03a30.92,30.92,0,0,1,1.318-11.573l.3-.755.282-.725-.07-.07-1.359,1.288a20.458,20.458,0,0,0-4.106,9.027,31.941,31.941,0,0,0-.614,6.974,105.233,105.233,0,0,1-.684,10.677v.05l-.443-1.369.141-.07.141-1.67-.091-.141-.362.181-.141.714-1.177-4.035-.141-1.389-.3-.3-.171-.614.151-.171L12.42,88.3l-.3-.121-.1-.443.473-.805-.091-.493-.825-.8-.07-.423.564-.916-.121-.664-.755-.584-.091.02-.02-.091.02.091-1.318.191-.4.3.07,1.489,1.016.372.9-.161.04-.02.07.392h-.181l-.946.141-.564.362.111,1.5,1,.332.946-.141.02-.02.07.372-1.278.191-.181.4.684,1.509.392.232.785-.161h.02l.091.4-.392.02-.4.654.423,1.137.845.262.121.533-.191-.04-.332.423.5,1.409.211.262.282-.161.231.825-.3-.121v.3L14,97.521l.05-.312,1.53,5.072a108.561,108.561,0,0,1-4.357-10.657l-2.9-5.535L6.784,85.4l-2.093.614-.191.493,1.348,3.935L7.358,96.1l2.325,5.283,1.61,1.57,1.389.362,2.777-.453.262-.161q1.63,4.876,3.6,9.681l1.811,4.991-.654.03-1.157.986-.4,1.771.1,3.089a89.324,89.324,0,0,0,2.093,11.613c.946,3.814,1.882,7.608,3.059,11.361-.674-3.874-1.409-7.708-2-11.573-.6-3.844-1.2-7.708-1.429-11.552l.04-2.777.191-.916,1.6,1.791L24.1,123.6a51.06,51.06,0,0,0,6.933,9.681l.161.161a35.607,35.607,0,0,0,5.988,5.515l2.848,2.174,2.214,1.459a70.97,70.97,0,0,0,9.449,5.484c12.166,5.917,25.641,8.513,38.723,10.113,3.22.453,6.4,1.057,9.59,1.791l-4.74,1.811a81.677,81.677,0,0,0-8.061,3.794l2.878,4.79a74.729,74.729,0,0,1,7.276-3.753c2.546-1.127,5.142-2.214,7.759-3.15l3.341-1.137.875.262q4.634,1.479,9.1,3.391a73.719,73.719,0,0,1,8.523,4.2l2.828-4.83a80.338,80.338,0,0,0-9.4-4.216l-3.462-1.248,4.357-.966c2.757-.594,5.494-1,8.322-1.419,2.848-.4,5.726-.845,8.554-1.389a116.523,116.523,0,0,0,16.815-4.428,78.267,78.267,0,0,0,19.512-9.832l2.194-1.479,2.828-2.214a36.04,36.04,0,0,0,5.937-5.565l.141-.161a50.135,50.135,0,0,0,6.833-9.761l1.509-2.425,1.58-1.811.211.916.05,2.777a110.932,110.932,0,0,1-1.3,11.573c-.523,3.864-1.228,7.708-1.862,11.573,1.107-3.743,2.053-7.567,2.948-11.381a93.988,93.988,0,0,0,1.952-11.643l.05-3.089-.4-1.761-1.177-.966-.664-.03.825-2c1.912-4.045,3.6-8.1,4.931-11.24L202.2,100.3l.634.232.7.1h.382l.372-.05.755-.211.755-.4.7-.564.614-.7.282-.382.121-.211.121-.191.3-.161.805-.493-.4.231-.4.242-.3.181-.684-.111h-.7l-.755.111-.735.262-.7.382-.684.463-.634.594-.312.3-.141.191-.04.05c1.077-3,2.143-6.32,2.969-9.167l.111-.211.242-.453.07-.181.725-.121.755-.241.382-.161.372-.211.7-.564.614-.684.523-.775.4-.875.161-.443.05-.242.04-.211.262-.282.664-.775v-.03ZM205.1,83.493l.3-.614.191.362.453.563.231.232.091.07-.3.4-.282.352-.07.02-.121-.493-.352-.7-.141-.161Zm-1.509-2.3.382-.262.352-.3.513-.594v.191l.03.825v.07l-.332.191-.684.564-.423.423-.07-.121-.382-.654Zm.191,4.619-.211.141-.564.513-.1-.322-.191-.473.382-.171.372-.232.121-.07.141.543Zm-1.721-3.935.775-.282.141-.07.171.3.211.352.07.141-.211.211-.574.785-.463.865-.332.755ZM201.747,86l.543-.151.423-.181.03.07.141.423.121.3v.03l-.1.07-.614.725-.513.805-.242.473Zm-.352,3.864.4-.05.805-.282.111-.05.05.382.191.654-.242.141-.513.4-.564-.352-.282-.1Zm-1.006,7.869.091.211.372.614-1.761,4.689Zm1.318,1.791-1.932,4.216,1.509-4.76.07.07.252.231.171.1Zm.111-4.015-.111-.282-.473-.563-.332-.231.121-.855.05.03.231-.03.02.151.352.634.382.443Zm.332,2.908.1-.785v-.443l-.03-.423-.161-.664.282-1.016.332.282.282.191.141.07.07.03Zm1.228-3.351.05-.282.04-.9-.02-.423-.07-.423v-.03l.07-.02.735-.614h.02l.02-.05.171-.161Z",
    transform: "translate(-4124.216 1238.945)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M29.156,51.659l-.262.443-.211.332-.7.4-.684.493-.634.594-.594.684-.493.755-.423.795-.332.855-.121.443-.04.211-.05.211h.02l.332-.141.121-.05.3-.111.735-.423.352-.262.352-.282.614-.684.523-.805.372-.865.231-.9.1-.473.02-.211v-.211l.211-.362.543-.886Z",
    transform: "translate(-3941.98 1267.18)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M28.3,51.63,28.137,52l-.684.5-.614.614-.594.674-.493.755-.4.805-.322.845-.221.875-.07.443-.02.211v.221h.02l.714-.433.141-.091.091-.091.121-.1.191-.141.07-.04.091-.07.332-.332.3-.352.543-.755.423-.875.262-.9.121-.916.02-.423v-.242L28.137,52l.181-.372.4-.946-.211.473Z",
    transform: "translate(-3940.999 1262.358)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M26.264,52.735l-.443.7-.382.785-.3.795-.191.825-.121.805-.02.392v.4h.02v-.02l.614-.523.091-.091.1-.091.091-.1.171-.161.04-.07.1-.091.252-.362.242-.352.423-.795.282-.825.161-.855.03-.845-.03-.4-.02-.181-.02-.171.111-.352.292-.946-.151.473-.161.453-.121.372-.543.564Z",
    transform: "translate(-3940.195 1258.054)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M24.954,53.9l-.091.775v.785l.07.725.091.332.05.191.07.161.02-.02.493-.644.453-.725.181-.4.151-.372.231-.825.091-.825-.04-.785-.191-.7-.141-.332-.07-.161-.07-.141.02-.332.05-.9-.03.453-.04.443-.03.332-.423.684-.352.725-.3.785Z",
    transform: "translate(-3939.664 1253.427)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M24.9,50.357l.141.262-.091.755.02.775.091.735.191.674.282.594.382.543.443.443.242.191.141.091.111.07h.03v-.04l.161-.785.07-.795v-.4l-.05-.372-.161-.735-.332-.634-.423-.493-.513-.382-.292-.141-.161-.07-.141-.02-.121-.262-.372-.664.161.332Z",
    transform: "translate(-3942.521 1253.372)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M14.917,73.395l.05-.091.091-.523.141-.614a5.05,5.05,0,0,1,5.354-4.216h.161a55.206,55.206,0,0,0,7.115-.493c3.421-.453,5.535-1.489,6.863-3.351l-.312-1.459-4.81-1.671-6.31-.493L18.55,60.2a23.079,23.079,0,0,1-6.32-1.419l-.614-.211-.07.614V60.1l.02.453,1.016,4.166-.352,1.771-.825.7-3.13,2.335-.282.211.181.3c1.63,1.771,4.005,2.506,6.551,3.26Z",
    transform: "translate(-4092.55 1333.844)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M11.664,63.666l-1.882.091H9.641l-.382.03.262.232.141.121,3.955,2.194a85.4,85.4,0,0,0,11.13,3.623l.9.07.463-.7.543-2.9.05-.282A17.737,17.737,0,0,0,24.887,59.4l-.121-.191-.121.151c-2.234,3.079-5.957,3.784-9.308,4.1Z",
    transform: "translate(-4081.085 1339.609)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M45.348,69.55l-3.16-2.335-.795-.7L41.01,64.74l1.037-4.166V59.185L42,58.571l-.6.232a22.165,22.165,0,0,1-6.34,1.389l-4.72.282-6.31.5-4.78,1.691-.312,1.459c1.318,1.862,3.421,2.9,6.863,3.351a60.885,60.885,0,0,0,7.084.473h.171a5.112,5.112,0,0,1,5.374,4.216l.111.634.121.493.05.121.181-.121c2.526-.755,4.931-1.459,6.551-3.22l.191-.312Z",
    transform: "translate(-3993.417 1333.835)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M19.624,70.026l.9-.05a80.469,80.469,0,0,0,11.12-3.653l3.985-2.184.121-.121L36,63.807l-.372-.03h-.141L33.6,63.666l-3.683-.211c-3.341-.312-7.064-1.016-9.308-4.076l-.111-.171-.1.191a17.126,17.126,0,0,0-1.811,6.742l.02.282.543,2.918Z",
    transform: "translate(-3996.535 1339.609)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M130.306,68.792l.161-5.988-1.338-2.8-.382-.262-.282.232-3.291,2.355a69.315,69.315,0,0,1-19.7,5.8c-7.608,1.157-15.1,1.681-21.444,2.033L81.44,70.3c-2.365.161-8.956.352-10.3.352S63.1,70.462,60.7,70.3l-2.566-.141c-6.34-.352-13.837-.875-21.465-2.033a68.983,68.983,0,0,1-19.683-5.8l-3.321-2.355-.252-.232-.382.262-1.338,2.8.141,5.988A7.8,7.8,0,0,1,9.78,75.836l-1.2,2.033L10.8,79.207a138.307,138.307,0,0,0,28.811,7.044,183.638,183.638,0,0,0,20.76,1.912c2.264.091,9.077.091,10.818.091l9.57-.05a184.856,184.856,0,0,0,21.8-1.952,138.1,138.1,0,0,0,28.791-7.044l2.234-1.338-1.2-2.033a7.731,7.731,0,0,1-2.073-7.044",
    transform: "translate(-4087.211 1344.475)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M19.408,69.812l1.268-.05-1.882-3.814.825-.473L20,64.549l.04-1.057-.825-1.862-1.831-.352-2.123.07.262,8.554,1.2-.02L16.6,66.108l1.016-.02ZM16.58,65.283l-.091-2.989.584-.03,1.63.523.141.916-.564,1.439-1.067.121Z",
    transform: "translate(-4026.679 1358.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M19.008,64.729l.423-1.439-.564-1.479-1.741-.523H14.691l.03,8.554h1.691L18.3,69.68l.725-.493.564-1.982L18.8,65.463l-.916-.242.533-.091Zm-.825,1.509.211,1.248-.916,1.389-.855.05h-.7v-3.2H16.6l1.248.181Zm-.825-1.459-.594.02h-.845V62.233h.7l1.228.241.4,1.037Z",
    transform: "translate(-4031.854 1358.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M20.322,70.014l.262-8.554-1.862-.07L17.143,69l-1.137-7.678-1.831-.05-.262,8.554,1.208.03.04-7.759,1.208,7.8,1.55.05,1.67-7.708L19.2,69.964Z",
    transform: "translate(-4038.912 1358.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M21.577,62.433,20.32,61.185H18.559l-1.842.191.916,8.5,1.821-.191,1.811-.423.845-1.741-.07-.946L21.879,64.7Zm-.664,5.374-.423.684-.946.231-.795.1-.714-6.6.614-.07,1.389.121.5,1.248.211,2.093Z",
    transform: "translate(-4013.492 1357.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M18.135,62.463l.05-.946L13.9,61.236l-.523,8.554,4.388.282.07-.966-3.19-.181.191-3.14,2.687.171.07-.966-2.707-.171.161-2.546Z",
    transform: "translate(-4043.778 1357.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M21.345,69.227l1.489.03,1.459-.926.161-1.389L24.2,65.836l-.644-1.721-1.107-.564-.684.07-1.147.946-.171-.644-.3-1.127.684-1.127.865.091.332.825,1.087-.282-.634-1.3-1.912-.262L19.6,61.2l-.473,2.194.966,3.653Zm.262-4.639.875.121.322.584.262.966.262,1.459-.664.614-.916-.161-.332-.664-.211-.795-.262-1.459Z",
    transform: "translate(-3991.614 1353.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M19.46,65.689l.191,2.194,1.338,1.58,1.228-.05.966-.473.735-1.318-.262-1.509-.825-1.369-.755-.141.282-.161.423-1.107-.231-1.087-.7-1.228-1.791-.141-1.137.574L18.6,63.4l.322,1.057.785.684.372-.02Zm2.948.443.161.574.171,1.006-.714.755-1.147-.7-.141-.4-.121-.543-.05-.916.664-.473Zm-2.546-2.3L19.7,63.3l.02-1.288.543-.312.966.312.262.725.181.946-.654.735-.805-.07Z",
    transform: "translate(-3996.472 1354.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M18.746,62.355l-.634.161.161.785,1.58-.312,1.268,6.622,1.208-.231-1.6-8.413-1.016.191Z",
    transform: "translate(-4000.848 1355.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M20.544,62.8l-.282-.735-2.043-.825-1.962.825-.4,1.882.121,2.315.312,2.687.322.513,1.932.594,1.681-.543.6-1.842-.02-.775-.02-1.509Zm-1.057,5.816-.916.564-1.107-.584-.171-1.228-.161-2.476-.02-.584.352-1.912.7-.262.966.352.282,1.177.121,1.791.04,1.137Z",
    transform: "translate(-4021.305 1358.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M21.572,61.079l-4.267.594,1.177,8.483,4.357-.594-.111-.966-3.16.443-.453-3.109,2.687-.352-.141-.966-2.657.352-.352-2.516,3.059-.423Z",
    transform: "translate(-4008.162 1356.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M20.627,65.412l.282,2.194,1.409,1.51,1.228-.121.946-.473.654-1.369-.332-1.509-.865-1.318-.755-.111.262-.171.352-1.127-.282-1.087-.755-1.177-1.791-.05-1.087.614L19.631,63.2l.382,1.036.825.634.372-.02Zm2.938.332.191.543.231,1.006-.684.785-1.177-.644-.161-.392-.141-.543-.091-.9.634-.523ZM20.929,63.55l-.161-.523-.05-1.288.513-.332,1,.262.282.724.211.946-.614.755-.805-.05Z",
    transform: "translate(-3987.083 1352.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M15.654,61.764,14,61.181l-1.821-.423-2,8.332,1.791.433,1.862.181L15.2,68.366l.262-.916.473-1.841.463-2.244Zm-.594,2.264-.473,2.053-.614,2.143-.614.493-.986-.07-.775-.211,1.55-6.461.614.141,1.248.574Z",
    transform: "translate(-4072.738 1353.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M16.514,62.683l.191-.946-4.247-.845L10.788,69.3l4.307.875.191-.946L12.177,68.6l.614-3.069,2.637.523.191-.946-2.637-.543.493-2.5Z",
    transform: "translate(-4067.223 1354.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M14.8,68.9l-.684-7.608-1.248-.1,1.057,8.694,1.56.141,2.566-8.383-1.248-.1Z",
    transform: "translate(-4048.414 1357.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M10.759,66.541l-1.067-.332L9.5,66.8l-.1.9,1.509,1.359,1.67-.04.956-1.248.282-.9.815-2.667.423-2.093-.231-.574-1.318-.865-1.4-.1-1.2,1.328-.473,1.409-.121,1.56,1.137.936,1.509-.091-.282.946-.171.493-.7,1.036-.594-.03-.574-.372-.07-.634Zm2.164-1.51-.765.05-.684-.714.02-.513.221-.684.161-.513.4-.9.976-.191.543.372.07.876-.473,1.55-.171.382Z",
    transform: "translate(-4079.807 1351.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M15.515,61.144l-2.053.473-.755,1.791-.282,2.284L12.265,68.4l.231.594,1.791.9,1.751-.262.936-1.7.121-.745.231-1.509.211-2.576-.141-.775Zm.755,2.616-.191,1.771-.141,1.127-.473,1.982-.986.372-.986-.725.04-1.258.282-2.465.07-.594L14.6,62.16l.725-.141.9.543Z",
    transform: "translate(-4053.841 1357.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M14.55,61.3l-1.67-.262-1.248,8.483,1.177.191.936-7.376.805,7.638,1.7.252L17.5,61.747l-1.157-.181L15.4,69.012Z",
    transform: "translate(-4059.578 1356.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M56.552,67.247c0,5.424-4.045,8.765-10.526,8.765h-4.9v6.712H35.51V58.432H46.026c6.481,0,10.526,3.371,10.526,8.815m-5.676,0c0-2.687-1.741-4.237-5.162-4.237H41.125v8.433h4.589c3.421,0,5.162-1.56,5.162-4.2",
    transform: "translate(-3843.169 1332.576)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M56.88,77.521H45.61l-2.164,5.2H37.7L48.508,58.431h5.565L64.931,82.723H59.024Zm-1.771-4.267-3.844-9.308L47.4,73.254Z",
    transform: "translate(-3823.321 1332.567)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M56.284,82.705l-4.689-6.762H46.432v6.762H40.8V58.433H51.3c6.481,0,10.556,3.341,10.556,8.805A7.871,7.871,0,0,1,56.868,74.9l5.444,7.809ZM51,63H46.432v8.463H51c3.442,0,5.162-1.61,5.162-4.227C56.163,64.561,54.443,63,51,63",
    transform: "translate(-3795.253 1332.585)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M62.334,77.521H51.064l-2.164,5.2H43.154L53.962,58.431h5.565L70.365,82.723H64.478Zm-1.771-4.267L56.7,63.946l-3.844,9.308Z",
    transform: "translate(-3773.891 1332.567)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M47.213,70.95c0-7.215,5.615-12.559,13.293-12.559,7.638,0,13.263,5.3,13.263,12.559S68.144,83.508,60.506,83.508c-7.678,0-13.293-5.344-13.293-12.559m20.881,0a7.6,7.6,0,1,0-15.2,0,7.6,7.6,0,1,0,15.2,0",
    transform: "translate(-3737.104 1332.204)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M72.6,67.247c0,5.424-4.076,8.765-10.556,8.765h-4.9v6.712H51.527V58.432H62.043c6.481,0,10.556,3.371,10.556,8.815m-5.706,0c0-2.687-1.721-4.237-5.162-4.237H57.142v8.433h4.589c3.442,0,5.162-1.56,5.162-4.2",
    transform: "translate(-3698.006 1332.576)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M54.039,70.95c0-7.215,5.615-12.559,13.293-12.559,7.608,0,13.263,5.3,13.263,12.559S74.94,83.508,67.332,83.508c-7.678,0-13.293-5.344-13.293-12.559m20.881,0a7.6,7.6,0,1,0-15.2,0,7.6,7.6,0,1,0,15.2,0",
    transform: "translate(-3675.24 1332.204)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M83.379,58.432,72.874,82.724H67.309L56.843,58.432H62.9l7.4,17.339,7.5-17.339Z",
    transform: "translate(-3649.826 1332.577)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M59.641,70.95c0-7.215,5.615-12.559,13.273-12.559S86.2,63.694,86.2,70.95,80.572,83.508,72.914,83.508,59.641,78.165,59.641,70.95m20.881,0a7.6,7.6,0,1,0-15.2,0,7.6,7.6,0,1,0,15.2,0",
    transform: "translate(-3624.468 1332.204)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M86.225,58.432V82.724H80.59V72.762H69.57v9.962H63.955V58.432H69.57V68H80.59v-9.57Z",
    transform: "translate(-3585.367 1332.577)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M66.728,70.95c0-7.215,5.615-12.559,13.293-12.559,7.638,0,13.293,5.3,13.293,12.559S87.659,83.508,80.021,83.508c-7.678,0-13.293-5.344-13.293-12.559m20.881,0a7.6,7.6,0,1,0-15.2,0,7.6,7.6,0,1,0,15.2,0",
    transform: "translate(-3560.238 1332.204)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M69.536,79.595l3.13-3.744,4.508,2.657c2.254,0,3.442-1.338,3.442-4.005V62.94H72.082V58.432H86.17V74.171c0,6.018-2.989,8.956-8.715,8.956a9.774,9.774,0,0,1-7.92-3.532",
    transform: "translate(-3534.789 1332.576)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M90.689,78.206v4.528H71.881v-24.3H90.236V62.94H77.466v5.273H88.737v4.357H77.466v5.635Z",
    transform: "translate(-3513.534 1332.575)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    "data-name": "Rectangle 508",
    width: 4.768,
    height: 4.768,
    transform: "matrix(0.709, -0.705, 0.705, 0.709, -3418.328, 1412.171)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M97.6,67.247c0,5.424-4.076,8.765-10.556,8.765h-4.9v6.712H76.524V58.432H87.04c6.481,0,10.556,3.371,10.556,8.815m-5.706,0c0-2.687-1.741-4.237-5.162-4.237H82.139v8.433h4.589c3.421,0,5.162-1.56,5.162-4.2",
    transform: "translate(-3471.456 1332.576)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M97.96,78.206v4.528H79.152v-24.3H97.507V62.94H84.737v5.273H96.028v4.357H84.737v5.635Z",
    transform: "translate(-3447.641 1332.575)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M81.6,58.432H87.21v19.7H99.4v4.589H81.6Z",
    transform: "translate(-3425.407 1332.577)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M83.633,70.95c0-7.215,5.635-12.559,13.293-12.559,7.638,0,13.293,5.3,13.293,12.559s-5.655,12.559-13.293,12.559c-7.658,0-13.293-5.344-13.293-12.559m20.881,0a7.6,7.6,0,1,0-15.2,0,7.6,7.6,0,1,0,15.2,0",
    transform: "translate(-3407.026 1332.204)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M109.02,67.247c0,5.424-4.076,8.765-10.556,8.765h-4.9v6.712H87.948V58.432H98.464c6.481,0,10.556,3.371,10.556,8.815m-5.706,0c0-2.687-1.721-4.237-5.162-4.237H93.563v8.433h4.589c3.442,0,5.162-1.56,5.162-4.2",
    transform: "translate(-3367.919 1332.576)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M90.46,70.95c0-7.215,5.615-12.559,13.273-12.559,7.628,0,13.283,5.3,13.283,12.559s-5.655,12.559-13.283,12.559c-7.658,0-13.273-5.344-13.273-12.559m20.881,0a7.6,7.6,0,1,0-15.2,0,7.6,7.6,0,1,0,15.2,0",
    transform: "translate(-3345.153 1332.204)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M119.8,58.432,109.295,82.724H103.73L93.264,58.432h6.058l7.4,17.339,7.5-17.339Z",
    transform: "translate(-3319.739 1332.577)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M96.061,70.95c0-7.215,5.615-12.559,13.293-12.559,7.638,0,13.293,5.3,13.293,12.559s-5.656,12.559-13.293,12.559c-7.678,0-13.293-5.344-13.293-12.559m20.881,0a7.6,7.6,0,1,0-15.2,0,7.6,7.6,0,1,0,15.2,0",
    transform: "translate(-3294.39 1332.204)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M100.186,80.7l1.912-4.237A14.171,14.171,0,0,0,110.108,79c3.321,0,4.689-1.127,4.689-2.616,0-4.538-14.119-1.409-14.119-10.435,0-4.126,3.321-7.557,10.224-7.557a16.427,16.427,0,0,1,8.443,2.143L117.6,64.791a13.841,13.841,0,0,0-6.732-1.9c-3.321,0-4.6,1.268-4.6,2.777,0,4.478,14.119,1.389,14.119,10.325,0,4.045-3.371,7.517-10.3,7.517-3.864,0-7.749-1.157-9.892-2.808",
    transform: "translate(-3257.005 1332.204)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M121.522,78.206v4.528H102.714v-24.3h18.365V62.94H108.3v5.273H119.59v4.357H108.3v5.635Z",
    transform: "translate(-3234.095 1332.575)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M127.265,82.724l-.05-14.581L120.08,80.158h-2.526L110.44,68.464V82.724h-5.273V58.431h4.639l9.1,15.1,8.956-15.1h4.609l.08,24.292Z",
    transform: "translate(-3211.864 1332.571)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M129.671,67.247c0,5.424-4.075,8.765-10.556,8.765h-4.9v6.712H108.6V58.432h10.516c6.481,0,10.556,3.371,10.556,8.815m-5.706,0c0-2.687-1.741-4.237-5.162-4.237h-4.589v8.433H118.8c3.422,0,5.162-1.56,5.162-4.2",
    transform: "translate(-3180.757 1332.576)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M126.714,82.705l-4.689-6.762h-5.162v6.762h-5.635V58.433h10.506c6.481,0,10.556,3.341,10.556,8.805A7.872,7.872,0,0,1,127.3,74.9l5.444,7.809ZM121.431,63h-4.569v8.463h4.569c3.442,0,5.162-1.61,5.162-4.227,0-2.677-1.721-4.237-5.162-4.237",
    transform: "translate(-3156.939 1332.585)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M132.708,78.206v4.528H113.9v-24.3h18.365V62.94h-12.78v5.273h11.291v4.357H119.485v5.635Z",
    transform: "translate(-3132.715 1332.575)",
    fill: "#003f62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    "data-name": "Rectangle 509",
    width: 4.768,
    height: 4.768,
    transform: "matrix(0.709, -0.705, 0.705, 0.709, -2995.487, 1412.171)",
    fill: "#003f62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColored);
export default __webpack_public_path__ + "static/media/logoColored.99da500f224a3e10a1848d173f31e386.svg";
export { ForwardRef as ReactComponent };